// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  display_banner: true,
  issuer: 'https://auth.staging.konekto.be/realms/EuroportsInlandTerminals',
  apiUrl: 'https://digiproc.api.euroports.staging.konekto.be/REST/eit/v1',
  wsUrl: 'wss://digiproc.api.euroports.staging.konekto.be/REST/eit/v1/ws',
  i18nUrl: '' // Keep empty to load local (/assets/i18n/[lang].json) lang files
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
